import { TableActionsWrapper } from '@components'

import { ReactElement } from 'react'

import { ImportedInvoicesPeriodSelector } from './elements/ImportedInvoicesPeriodSelector'
import { ImportedInvoicesSearch } from './elements/ImportedInvoicesSearch'

export const ImportedInvoicesTableActions = (): ReactElement => {
  return (
    <TableActionsWrapper>
      <ImportedInvoicesSearch />
      <ImportedInvoicesPeriodSelector />
    </TableActionsWrapper>
  )
}
